import { SPACING_SIZE, SPACINGS } from "../spacings.ts";

type Props = {
	size: SPACING_SIZE;
	direction?: "vertical" | "horizontal";
};

function Separator({ size, direction = "vertical" }: Props) {
	const spacingDimension = SPACINGS[size];

	return (
		<div
			style={
				direction === "vertical"
					? { height: spacingDimension, width: "100%", flexShrink: 0 }
					: { width: spacingDimension, height: "100%", flexShrink: 0 }
			}
		/>
	);
}

export default Separator;
